<script lang="ts">
  import ContentContainer from "../components/content-box-system/ContentContainer.svelte";
  import ContentSection from "../components/content-box-system/ContentSection.svelte";
  import type { GetServersResponse } from "../../functions/src/modules/servers";
  import { loadJSON } from "../loader";

  const servers = loadJSON<GetServersResponse>("/api/servers", {
    alwaysReload: true,
  });
</script>

<main>
  <ContentContainer classNames="pure-g">
    <div class="pure-u-1-1">
      <ContentSection title="Game Servers">
        <h3>Server List</h3>
        {#await servers}
          <div class="spinner" />
        {:then servers}
          <div class="server-list">
            {#each servers as server}
              <div class="name">{server.hostname}</div>
              <div class="map">{server.map}</div>
              <div class="game">{""}</div>
              <div class="players">{server.humans}/{server.maxPlayers}</div>
              <div class="address">{server.host}</div>
            {/each}
          </div>
        {/await}
      </ContentSection>
    </div>
  </ContentContainer>
</main>

<style lang="scss">
  .server-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }
</style>
